/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Empty_Onboarding_TitleInputs */

const cs_chat_empty_onboarding_title = /** @type {(inputs: Chat_Empty_Onboarding_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte konverzaci`)
};

const en_chat_empty_onboarding_title = /** @type {(inputs: Chat_Empty_Onboarding_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a conversation`)
};

/**
* | output |
* | --- |
* | "Select a conversation" |
*
* @param {Chat_Empty_Onboarding_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_empty_onboarding_title = /** @type {((inputs?: Chat_Empty_Onboarding_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Empty_Onboarding_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_empty_onboarding_title(inputs)
	return cs_chat_empty_onboarding_title(inputs)
});